import { render, staticRenderFns } from "./BlackListView.vue?vue&type=template&id=8ca08082&scoped=true&"
import script from "./BlackListView.vue?vue&type=script&lang=js&"
export * from "./BlackListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca08082",
  null
  
)

export default component.exports